import moment from 'moment'
import actions from './actions'
import getters from './getters'
import * as types from './types'

const dateNow = moment().format('YYYY-MM-DD')
const dateNowMinus60 = moment().subtract(60, 'days').format('YYYY-MM-DD')

const state = {
  positions: [],
  filters: {
    companyId: '',
    accountId: '',
    startDate: dateNowMinus60,
    endDate: dateNow,
    // Should be all pre selected so the call don't fail
    types: ['TRADE', 'DELINQUENT', 'DEFAULTED', 'COMPLETED']
  },
  pagination: {
    page: 1,
    itemsPerPage: 20
  },
  totalItems: 0,
  isLoading: false,
  accounts: []
}

const mutations = {
  [types.SET_POSITIONS](state, newPositions) {
    state.positions = newPositions
  },
  [types.SET_PAGINATION](state, newPagination) {
    state.pagination = newPagination
  },
  [types.SET_TOTAL_ITEMS](state, newTotalItems) {
    state.totalItems = newTotalItems
  },
  [types.SET_IS_LOADING](state, turn) {
    state.isLoading = turn
  },
  [types.SET_FILTERS](state, { key, value }) {
    state.filters = {
      ...state.filters,
      [key]: value
    }
  },
  [types.SET_ACCOUNTS](state, accounts) {
    state.accounts = accounts
  },
  [types.SET_CLEAR_ACCOUNTS](state) {
    state.filters.accountId = ''
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
